// Shorts.js
'use strict';
import { connect } from 'react-redux';
import { LRUCache } from 'lru-cache';
import { replace } from 'redux-first-history';

import { MERGE_OPERATION_DATA } from '../ActionTypes.js';

import {
  SHORTS_FEED_ALIAS,
  LIVESTREAM_CLIP_FEED_ALIAS,
  SHORTS_PREFETCHED_MESSAGE_AMOUNT,
} from '../RemoteConfigKeys.js';

import fetchFeeds, { getReturnType } from '../action/fetchFeeds.js';
import fetchAndPrependMessageId from '../action/fetchAndPrependMessageId.js';
import setFirstShortMessagePlayed from '../action/setFirstShortMessagePlayed.js';
import addMessageIdToShortWatchedList from '../action/addMessageIdToShortWatchedList.js';

import Shorts from '../page/Shorts.jsx';
import withRouter from '../component/WithRouter.jsx';

import getMeData from '../selector/getMeData.js';
import getListData from '../selector/getListData.js';
import getOperationData from '../selector/getOperationData.js';
import getNetworkingData from '../selector/getNetworkingData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getIsRemoteConfigMerged from '../selector/getIsRemoteConfigMerged.js';
import getShortsIds from '../selector/getShortsIds.js';

import {
  CONFIG_PRIORITY_PRESENCE_CLIENT,
  CONFIG_PRIORITY_PRESENCE_USER,
} from '../resource/configPriority.js';
import { breakpoint } from '../style/variables.js';

const cache = new LRUCache({ max: 256 });
const getSelectPath = ({ category } = {}) => {
  const key = `${category}`;
  let result = cache.get(key);
  if (!result) {
    result = ['shorts', category];
    cache.set(key, result);
  }
  return result;
};

const mapStateToProps = (state, { match, location }) => {
  const messageIdFromUrl = match?.params?.messageId;
  const listPath = location?.state?.listPath;
  const prefetchedMessageAmount = getRemoteConfigData(
    state,
    SHORTS_PREFETCHED_MESSAGE_AMOUNT
  );
  const category =
    location?.state?.category || getRemoteConfigData(state, SHORTS_FEED_ALIAS);
  const clipCategory = getRemoteConfigData(state, LIVESTREAM_CLIP_FEED_ALIAS);
  const shortsSelectPath = listPath || getSelectPath({ category });
  const itemIds = listPath
    ? getListData(state, listPath, 'itemIds')
    : getShortsIds(state, category, clipCategory);
  const clipSelectPath = [
    'home',
    getReturnType({ feedName: clipCategory }),
    clipCategory,
  ];
  const nextPage = getListData(state, shortsSelectPath, 'nextPage');
  const clipNextPage = getListData(state, clipSelectPath, 'nextPage');
  const isNextPageFetching = !!getNetworkingData(
    state,
    [...shortsSelectPath, nextPage],
    'isFetching'
  );
  const feedId = getOperationData(
    state,
    ['fetchedRenewFeedId', category],
    'id'
  );
  const deviceWidth = getOperationData(state, ['device'], 'width');
  const hasToken = !!getMeData(state, 'token');
  const isPresenceClientRemoteConfigMerged = getIsRemoteConfigMerged(
    state,
    CONFIG_PRIORITY_PRESENCE_CLIENT
  );
  const isPresenceUserRemoteConfigMerged = getIsRemoteConfigMerged(
    state,
    CONFIG_PRIORITY_PRESENCE_USER
  );
  return {
    deviceHeight: getOperationData(state, ['device'], 'height'),
    lastWatchedShortIndex: getOperationData(
      state,
      ['feed', feedId],
      'lastWatchedIndex'
    ),
    messageIdFromUrl,
    feedId,
    clipFetchedFeedId: getOperationData(
      state,
      ['fetchedRenewFeedId', clipCategory],
      'id'
    ),
    clipLatestFeedId: getOperationData(
      state,
      ['renewFeedId', clipCategory],
      'id'
    ),
    category,
    clipCategory,
    shortsSelectPath,
    itemIds,
    nextPage,
    clipNextPage,
    clipLatestTimestamp: getOperationData(
      state,
      ['renewFeedId', clipCategory],
      'timestamp'
    ),
    isClipFirstPageFetching: !!getNetworkingData(
      state,
      [...clipSelectPath, 1],
      'isFetching'
    ),
    isClipFirstPageFetched: !!getNetworkingData(
      state,
      [...clipSelectPath, 1],
      'isFetched'
    ),
    isNextPageFetching,
    isOnDesktop: deviceWidth && deviceWidth > breakpoint.tablet,
    isConfigMerged: hasToken
      ? isPresenceUserRemoteConfigMerged
      : isPresenceClientRemoteConfigMerged,
    shouldShowBack: location?.state?.shouldShowBack,
    prefetchedMessageAmount,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchFeeds: payload => dispatch(fetchFeeds(payload)),
    setLastWatchedIndex: ({ lastWatchedIndex, feedId }) =>
      dispatch({
        type: MERGE_OPERATION_DATA,
        payload: {
          selectPath: ['feed', feedId],
          data: {
            lastWatchedIndex,
          },
        },
      }),
    fetchAndPrependMessageId: payload =>
      dispatch(fetchAndPrependMessageId(payload)),
    replace: (...args) => dispatch(replace(...args)),
    setFirstShortMessagePlayed: data =>
      dispatch(setFirstShortMessagePlayed(data)),
    addMessageIdToShortWatchedList: data =>
      dispatch(addMessageIdToShortWatchedList(data)),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Shorts));
